import * as $ from 'jquery';
import { Observable } from 'common/barrels/rx';

import { ContainerControl } from 'runtime/controls/containercontrol';
import { ControlArgs } from 'runtime/controls/controlargs';
import { TabContainer } from 'runtime/controls/tabcontainer';
import { registerBinding } from 'runtime/bindingengine';

import 'runtime/styles/controls/tabitempanelcontainer.less';

export class TabItemPanelContainer extends ContainerControl {

    private tabContainer: TabContainer;
    private $container: JQuery;

    constructor(args: ControlArgs) {
        super(args);

        this.methods.register(this.config.elementName, this);

        this.$element.addClass('tabitempanelcontainer')

        this.visible = this.config['isElementVisible'];
        this.enabled = this.config['isElementEnabled'];

        this.subscriptions = this.processBindings(this.config);

        this.$container = this.prepareContainer();

        this.bindElements(this.$container.children(), this);

        this.parentEnabled = true;
    }

    private prepareContainer() {
        var $children = this.$element.children();

        var $container = $('<div />')
            .addClass('tabitempanelcontainer-container')
            .addClass(this.config.isScrollable ? 'tabitempanelcontainer-container-scrollable' : 'tabitempanelcontainer-container-notscrollable')
            .appendTo(this.$element);

        $container.applyBackground(this.config['content.Background']);

        var $sizing = $('<div />')
            .appendTo($container)
            .addClass('tabitempanelcontainer-sizing')
            .conditionalCss(this.config.minimumInteriorHeight, 'min-height')
            .conditionalCss(this.config.minimumInteriorWidth, 'min-width');

        var $sizingFix = $('<div />')
            .addClass('tabitempanelcontainer-fix')
            .appendTo($sizing)
            .append($children);

        return $sizingFix;
    }

    protected defaultActivated() {
        return false;
    }

    registerTab(container: TabContainer) {
        container.registerTab(
            this.config.tabItem, this.config['content.LanguageKey'], this.$element, this, this.derivedEnabledState(), this.derivedVisibilityState(),
            x => this.activatedSubject.next(x), x => this.visibilitySubject.next(x)
        );
        this.tabContainer = container;
    }

    elementName() {
        return this.config.elementName;
    }

    tabItem(): string {
        return this.config.tabItem;
    }

    open() {
        this.tabContainer['select Tab By Name'](this.config.tabItem);
    }

    focus() {
        this.tabContainer.focus();
    }

    // this is a bit special because our own enabled state means something different to the tab control (tab disabled), so we propagate the value without accepting it as our own
    isParentEnabled(value: boolean) {
        this.propagateEnabledStateToChildElements(this.$container, value);
    }

    applyEnabledState(value: boolean) {
        if (this.tabContainer)
            this.tabContainer.tabEnabledChanged(this.config.tabItem, value);
    }

    applyVisibleState(value: boolean) {
        if (this.tabContainer)
            this.tabContainer.tabVisibleChanged(this.config.tabItem, value);
    }

    resizeStream(): Observable<{}> {
        return this.container.resizeStream();
    }
}

registerBinding('tabitempanelcontainer', TabItemPanelContainer);